import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useGetActivitiesBySubTopic } from '../../../hooks/useGetActivitiesBySubTopic';
import { tasksId } from '../../../types/activityTasks';
import ObserverEmitter, { EVENTS } from '../../../emitter/Observer';
import { audiosAssets } from '../../../assets/audio';
import { ButtonHome } from '../../../components/common/ButtonHome';
import { ButtonPlay } from '../../../components/common/ButtonPlay';
import { HeaderRedPresentation } from '../../../components/common/HeaderRedPresentation';
import { DialogBarNew } from '../../../components/common/DialogBarNew';
import { PanelActivities } from '../../../components/common/PanelActivities';
import { ValidationResultModal } from '../../../components/common/ValidationResultModal';
import { completeOneTask } from '../../../store/slices/menu/tunks';
import { BarStatusActivies } from '../../../components/common/BarStatusActivies';
import { voicesTypeControl } from '../../../types/audioType';
import { ButtonReturn } from '../../../components/common/ButtonReturn';


const steps = {
	dialogInitial: 1,
	panelActivities: 2,
	dialogTwo: 3,
	dialogThree: 4,
	dialogFour: 5,
	dialogFive: 6,
	win: 8
};

const stepThree = {
	view_koaxka: steps.dialogThree,
	Bolsa: steps.dialogFour,
	go_back: steps.dialogFive
}

const stepThreeAudio = {
	view_koaxka: {
		action: () => {
			ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T3.subtema_2.sub2_act4_a03T3)
		}
	},
	Bolsa: {
		action: () => {
			ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T3.subtema_2.sub2_act4_a04T3)
		}
	},
	go_back: {
		action: () => {
			ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T3.subtema_2.sub2_act4_a05T3)
		}
	},
}


export const Theme3SubtopicTwoActivityFour = () => {
	const navigator = useNavigate()
	const dispatch = useDispatch()
	const { loaded, activitiesInformation } = useSelector((state) => state.menu);
	const { tasksList, points } = useGetActivitiesBySubTopic(activitiesInformation[tasksId.tema3.activities.subtema2], 4);
	const [uiToShow, setUiToShow] = useState(steps.dialogInitial);

	useEffect(() => {
		if (loaded) {
			console.log("theme 3 sub 2 act 4");
			ObserverEmitter.emit(EVENTS.tema3.topic2.initScene, 4);
			ObserverEmitter.emit(EVENTS.audiosEvents.pauseActive, true)
			ObserverEmitter.emit(EVENTS.audiosEvents.createAudioScene, audiosAssets.escenarios.onOxxoScene)
		}
	}, [loaded]);

	ObserverEmitter.on(EVENTS.audioInitByTopic, () => {
		ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T3.subtema_2.sub2_act4_a01T3)
	})

	ObserverEmitter.on(EVENTS.tema3.topic2.actFour.finishMoveActBolsa, (step = "") => {
		const stepSelect = stepThree[step]
		if (!stepSelect) {
			return
		}
		setUiToShow(stepSelect)

		const stepAudio = stepThreeAudio[step]
		stepAudio.action()
	})

	return (
		<>
			<>
				<ButtonPlay />
				<ButtonHome />
				{![1, -1, -2].includes(uiToShow) && (
					<ButtonReturn callback={() => {
						ObserverEmitter.emit(EVENTS.tema3.topic2.initScene, 4);
						setUiToShow(1)
					}} />
				)}
			</>

			{uiToShow === steps.dialogInitial && (
				<>
					<HeaderRedPresentation name="Actividad 1: Caducidad de productos" />
					<DialogBarNew
						dialog={`Debes revisar todos los días el Koxka y el Salchikoxka para retirar los productos caducados o en mal estado.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
							setUiToShow(steps.panelActivities);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.panelActivities && (
				<>
					<PanelActivities
						buttonText="¡Comenzar!"
						title="Subtema 2: Máquina Warmer y Koxka y Salchikoxka"
						titleActivity="Actividades por realizar:"
						points={points}
						insigniaBackground={0}
						actionButton={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T3.subtema_2.sub2_act4_a02T3)
							ObserverEmitter.emit(EVENTS.tema3.topic2.actFour.actBolsa, "view_garbage_bag")
							setUiToShow(steps.dialogTwo);
						}}
						activities={tasksList}
					/>
				</>
			)}

			{uiToShow === steps.dialogTwo && (
				<>
					<BarStatusActivies
						activities={tasksList}
					/>
					<DialogBarNew
						dialog={`Los productos detectados deben ser colocados en una bolsa de plástico. Luego, debes llevar la bolsa al contenedor de mermas en el Cuarto Frío. `}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
							ObserverEmitter.emit(EVENTS.tema3.topic2.actFour.actBolsa, "select_product_time_out")
							setUiToShow(-1);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogThree && (
				<>
					<DialogBarNew
						dialog={`Haz click en los productos, defectuosos o caducados para trasladarlos a la bolsa correspondiente.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
							ObserverEmitter.emit(EVENTS.tema3.topic2.actFour.actBolsa, "move_room_cold")
							setUiToShow(-1);
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.dialogFour && (
				<>
					<DialogBarNew
						dialog={`Deposita la bolsa negra con los productos en mal estado en el contenedor de merma.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
							ObserverEmitter.emit(EVENTS.tema3.topic2.actFour.actBolsa, "go_back")
							setUiToShow(-1);
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.dialogFive && (
				<>
					<DialogBarNew
						dialog={`Si es necesario, etiqueta los productos a exhibir. Debes tener a la mano el planograma y con él utilizar el método PEPS. `}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
							ObserverEmitter.emit(EVENTS.tema3.topic2.actFour.actBolsa)
							setUiToShow(steps.win);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.win && (
				<>
					<ValidationResultModal
						title="¡Bien hecho!"
						dialogModal="No podemos permitir que el cliente se lleve un producto caducado."
						buttonTxt="Continuar"
						isCorrect={true}
						action={() => {
							dispatch(
								completeOneTask({
									idActivity: 4,
									pointsWin: 0,
									subtema: tasksId.tema3.activities.subtema2
								})
							);
							navigator("/home3/tema3/subtema2/activityFive");
						}}
					/>
				</>
			)}

		</>
	)
}
